module.exports = __webpack_public_path__ + "img/close.10f030bb.svg";